import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"

import DevInspectorUI from "@frog/source/views/DevInspectorUI.jsx"
import DevPaletteUI from "@frog/source/views/DevPaletteUI.jsx"

import "@frog/source/views/DevPanes.less"

export default class DevPanes {
    render() {
        if(Dev.isInspectorShowing() != true) {
            return this.props.children
        }
        return (
            <div class="DevPanes" key="dev">
                <DevHeader/>
                <div class="DevBody">
                    <DevPaletteUI/>
                    <div class="DevPlaySection">
                        <div class="DevPlayHeader" inProtoMode={Dev.inProtoMode}>
                            <div class="PausePlayButton"
                                title={Dev.inProtoMode ? "Play" : "Pause"}
                                onClick={this.onClickPausePlayButton}>
                                <span class="material-symbols-rounded">
                                    {Dev.inProtoMode ? "play_arrow" : "pause"}
                                </span>
                            </div>
                            <div class="StopButton" title="Stop" onClick={this.onClickStopButton}>
                                <span class="material-symbols-rounded">stop</span>
                            </div>
                        </div>
                        <div class="DevPreview">
                            {this.props.children}
                        </div>
                        <div class="DevPlayFooter" inProtoMode={Dev.inProtoMode}>
                            <span class="PointerPosition">
                                {App.game?.chapter?.selection?.position?.x || 0}
                                <span>x</span>
                                {App.game?.chapter?.selection?.position?.y || 0}
                            </span>
                            <div class="Spacer"/>
                            <span class="Mode">
                                {Dev.inProtoMode ? "EDIT" : "PLAY"}
                            </span>
                        </div>
                    </div>
                    <DevInspectorUI/>
                </div>
            </div>
        )
    }
    onClickPausePlayButton() {
        Dev.inProtoMode = !Dev.inProtoMode
    }
    onClickStopButton() {
        if(App.game.chapter == undefined) return
        if(Dev.inProtoMode == true) return
        App.game.chapter.restart()
        Dev.inProtoMode = true
    }
}

class DevHeader {
    render() {
        return (
            <div class="DevHeader">
                <div class="Dropdown">
                    <div class="Dropbutton">
                        File
                    </div>
                    <div class="DropdownContent">
                        <div class="Option" onClick={() => {Dev.saveUnitsToFile()}}>
                            Save <span class="Legend">⌘S</span>
                        </div>
                    </div>
                </div>
                <div class="Dropdown">
                    <div class="Dropbutton">
                        Edit
                    </div>
                    <div class="DropdownContent">
                        <div class="Option" onClick={this.onClickingUndo()}>
                            Undo <span class="Legend">⌘Z</span>
                        </div>
                        <div class="Option" onClick={this.onClickingRedo()}>
                            Redo <span class="Legend">⌘⇧Z</span>
                        </div>
                        <div class="Option" onClick={async () => {Dev.clipUnit(); Dev.deleteSelectedUnit()}}>
                            Cut <span class="Legend">⌘X</span>
                        </div>
                        <div class="Option" onClick={async () => {Dev.clipUnit()}}>
                            Copy <span class="Legend">⌘C</span>
                        </div>
                        <div class="Option" onClick={async () => {Dev.pasteUnit()}}>
                            Paste <span class="Legend">⌘V</span>
                        </div>
                    </div>
                </div>
                <div class="Dropdown">
                    <div class="Dropbutton">
                        View
                    </div>
                    <div class="DropdownContent">
                        <div class="Option" onClick={() => {Dev.areDevPanelsOpen = !Dev.areDevPanelsOpen}}>
                            Toggle Panels <span class="Legend"> - </span>
                        </div>
                        <div class="Option" onClick={() => {Dev.inProtoMode = !Dev.inProtoMode}}>
                            Toggle Protomode <span class="Legend"> = </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    onClickingUndo() {
        return () => {
            if(Dev.inProtoMode == true) {
                Dev.loadProtoUnitsToUndo()
            } else {
                App.game.chapter.undoAction()
            }
        }
    }
    onClickingRedo() {
        return () => {
            if(Dev.inProtoMode == true) {
                Dev.loadProtoUnitsToRedo()
            }
        }
    }
}
